import { Goal, MetricEntry, MetricEntryMode } from '@griply/types';
import { calculateMetricEntryValue, formatDateKey } from '@griply/utils';
import { useMemo } from 'react';

export const useGoalMetricDayProgress = (goal?: Goal) =>
  useMemo(() => {
    const uniqueEntries = new Map<string, MetricEntry>();

    goal?.metric?.entries?.forEach((entry) => {
      const dateKey = formatDateKey(entry.date);
      const existingUniqueEntry = uniqueEntries.get(dateKey);

      if (
        existingUniqueEntry &&
        existingUniqueEntry.date.getTime() > entry.date.getTime()
      ) {
        return;
      }

      uniqueEntries.set(dateKey, {
        ...entry,
        value: calculateMetricEntryValue(
          entry.id,
          // eslint-disable-next-line -- entries exist as we are looping over them
          goal?.metric?.entries!,
          goal?.metric?.startValue ?? 0,
        ),
        mode: MetricEntryMode.Absolute,
      });
    });

    return Array.from(uniqueEntries.values()).sort(
      (entryA, entryB) => entryA.date.getTime() - entryB.date.getTime(),
    );
  }, [goal?.metric?.entries, goal?.metric?.startValue]);
